// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-video{position:relative;width:100%;height:0;padding-top:calc(100% / 16 * 9);margin-top:2rem;margin-bottom:2rem}.czt-video>div,.czt-video>iframe{position:absolute;top:50%;left:50%;width:100%;height:100%;transform:translate3d(-50%, -50%, 0)}", ""]);
// Exports
module.exports = exports;
